<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card no-body>
        <b-card-body>
          <b-overlay :show="loading" rounded="md" variant="transparent">
            <validation-observer ref="detailWebhookValidate">
              <b-form ref="detailWebhookFormElement">
                <b-row>
                  <b-col sm="12">
                    <b-form-group label-for="endpoint" :label="t('Endpoint')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Endpoint')"
                        rules="required|url"
                      >
                        <b-form-input
                          id="endpoint"
                          v-model="values.endpoint"
                          name="endpoint"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Endpoint')"
                          :tabindex="6"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12">
                    <b-form-group label-for="description" :label="t('Description')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Description')"
                        rules="required"
                      >
                        <b-form-input
                          id="description"
                          v-model="values.description"
                          name="description"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Description')"
                          :tabindex="6"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6">
                    <b-form-group label-for="origin" :label="t('Service Type')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Service Type')"
                        rules="required"
                      >
                        <v-select
                          id="origin"
                          v-model="values.dataType"
                          :options="serviceTypes"
                          :reduce="item => item.value"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="3"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12" md="6">
                    <b-form-group label-for="origin" :label="t('Subscribe Event Type')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Subscribe Event Type')"
                        rules="required"
                      >
                        <v-select
                          id="origin"
                          v-model="values.subscribedEvent"
                          :options="subscribeTypes"
                          :reduce="item => item.value"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="3"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col v-if="values.dataType === 'SOAP'" sm="12">
                    <b-form-group label-for="soapData" :label="t('SOAP Data')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('SOAP Data')"
                        rules="required|json"
                      >
                        <b-form-textarea
                          id="soapData"
                          v-model="values.data"
                          rows="10"
                          name="soapData"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('SOAP Data')"
                          :tabindex="6"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12">
                    <b-form-group label-for="securityType" :label="t('Security Type')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Security Type')"
                        rules="required"
                      >
                        <v-select
                          id="securityType"
                          v-model="values.securityType"
                          :options="securityTypes"
                          :reduce="item => item.value"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="3"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="values.securityType && values.securityType !== 'none'" class="mb-1">
                    <security-form
                      :type="values.securityType"
                      :initial-values="values.securityData"
                      @change="val => (values.securityData = val)"
                    />
                  </b-col>

                  <b-col sm="12">
                    <b-form-checkbox
                      v-model="values.status"
                      name="check-button"
                      switch
                      tabindex="10"
                    >
                      {{ values.status ? t('Active') : t('Passive') }}
                    </b-form-checkbox>
                  </b-col>

                  <b-col sm="12">
                    <b-button
                      variant="primary"
                      type="button"
                      class="mt-2"
                      :disabled="submitting"
                      @click="submit"
                    >
                      <feather-icon icon="CheckIcon" size="15" />

                      {{ submitting ? t('Please Wait') : type === 'new' ? t('Add') : t('Edit') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-overlay>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import {
  BButton,
  BCard,
  BCardBody,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BRow,
  BFormCheckbox,
  BFormTextarea
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import { securityTypes, subscribeTypes, serviceTypes } from '@/constants/webhooks.constants';
import SecurityForm from './SecurityForm.vue';

export default {
  components: {
    BButton,
    BCard,
    BCardBody,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BRow,
    BFormCheckbox,
    BFormTextarea,
    vSelect,

    ValidationObserver,
    ValidationProvider,
    SecurityForm
  },
  mixins: [helper],
  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          description: '',
          dataType: 'JSON',
          subscribedEvent: '',
          endpoint: '',
          securityType: '',
          securityData: null,
          data: '',
          status: true
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      securityTypes: securityTypes.map(i => ({ ...i, text: this.$t(i.text) })),
      subscribeTypes: subscribeTypes.map(i => ({ ...i, text: this.$t(i.text) })),
      serviceTypes: serviceTypes.map(i => ({ ...i, text: this.$t(i.text) }))
    };
  },
  methods: {
    submit() {
      this.$refs.detailWebhookValidate.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            ...this.values,
            status: this.values.status ? 1 : 0,
            securityData: this.values.securityType !== 'none' ? this.values.securityData : []
          });
        }
      });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
